module.exports = __webpack_public_path__ + "static/media/closeRedCircle.26c078d5.svg";